import docReady from 'doc-ready'
import {initContainers} from '../util/init'
import {initCarousel} from './flickity'
import ScrollBalance from '../scrollbalance'
import {MAX_MOBILE} from './constants'
import {createMap} from './map'
import {updateLinkState} from '../util/link_state'
import {addHandler} from '../util/scroll_resize'
import navigation from './navigation'
import offset from 'document-offset'
import {VideoPlayer} from './videoplayer'

// function commonInit (containers) {
//
// }

function peopleSetup () {
  const wrap = document.querySelector('#footer .people')
  const bioWrap = wrap.querySelector('.bio-wrap')
  const people = Array(...wrap.querySelectorAll('.person-listing'))
  const bios = []

  people.forEach((person, i) => {
    // pull out bio content
    const bio = person.querySelector('.bio')
    bioWrap.appendChild(bio)
    bios.push(bio)

    // show on click
    person.addEventListener('click', () => {
      showBio(i)
    })
  })

  const showBio = (index) => {
    for (let i = 0; i < people.length; i++) {
      people[i].classList[i === index ? 'add' : 'remove']('active')
      bios[i].classList[i === index ? 'add' : 'remove']('active')
    }
    window.scroll({
      top: offset(bioWrap).top,
      behavior: 'smooth'
    })
  }
}

function fixBottomImage (menu) {
  const image = document.querySelector('#header .bottom-image')
  let threshold
  let fixed = false

  const setState = (shouldFix) => {
    if (shouldFix !== fixed) {
      fixed = shouldFix
      if (fixed) {
        document.body.classList.add('state-bottom-image-fixed')
        menu.toggle(false)
      } else {
        document.body.classList.remove('state-bottom-image-fixed')
      }
    }
  }
  const resize = (ww, wh) => {
    threshold = offset(image).top + Math.max(0, image.offsetHeight - wh)
  }
  const scroll = (st, sl) => {
    setState(st > threshold)
  }

  addHandler({
    resize: resize,
    scroll: scroll
  }, true)
}

function fixContentNav () {
  const nav = document.querySelector('#content-nav')
  let threshold
  let fixed = false

  const setState = (shouldFix) => {
    if (shouldFix !== fixed) {
      fixed = shouldFix
      document.body.classList[fixed ? 'add' : 'remove'](
        'state-content-nav-fixed')
    }
  }

  addHandler({
    resize: (ww, wh) => {
      threshold = offset(nav).top
    },
    scroll: (st, sl) => {
      setState(st > threshold)
    }
  }, true)
}

function initMenu () {
  let menuVisible = false

  const toggle = (visible = null) => {
    if (visible === null) {
      menuVisible = !menuVisible
    } else {
      menuVisible = visible
    }
    document.body.classList[menuVisible ? 'add' : 'remove']('state-menu-visible')
  }

  document.querySelector('#burger').addEventListener('click', e => {
    e.preventDefault()
    toggle()
  })

  // show for dev convenience
  if (window.location.search === '?showmenu') {
    document.body.classList.add('state-menu-visible')
    menuVisible = true
  }

  return {
    toggle: toggle
  }
}

function setup () {
  // commonInit(document.querySelectorAll('#header, #footer'))

  const menu = initMenu()

  const featuredVideos = document.querySelectorAll('#header .video-player')
  Array(...featuredVideos).forEach(function(videoEl) {
    new VideoPlayer(videoEl, {})
  })

  const carousels = document.querySelectorAll('#header .featured-carousel')
  Array(...carousels).forEach(initCarousel)

  const projects = document.querySelector('#header .featured-projects')
  addHandler(new ScrollBalance([projects], {
    minwidth: MAX_MOBILE + 1
  }), true)

  const canvasA = document.querySelector('#footer .map-wrap-auckland .map')
  const coordsA = [-36.86963, 174.77651]
  createMap(canvasA, coordsA)


  const canvasQ = document.querySelector('#footer .map-wrap-queenstown .map')
  const coordsQ = [-45.012133487267654, 168.7430434423281]
  createMap(canvasQ, coordsQ)

  fixBottomImage(menu)
  fixContentNav()

  navigation(initContent, menu)

  // state triggers for when different elements hit the top of the page. used
  // by mobile to control hamburger colour
  // let featuredProjectsTop, bottomQuoteTop, contentTop
  const triggers = [
    {
      el: document.querySelector('#header .featured-projects'),
      className: 'state-featured-projects-at-top'
    }, {
      el: document.querySelector('#header .bottom-quote'),
      className: 'state-bottom-quote-at-top'
    }, {
      el: document.querySelector('#content'),
      className: 'state-content-at-top'
    }
  ]
  addHandler({
    resize: () => {
      triggers.forEach((trigger) => {
        trigger.offset = offset(trigger.el).top
      })
    },
    scroll: (st, sl) => {
      const classes = document.body.classList
      triggers.forEach((trigger) => {
        const active = st >= (trigger.offset - 40)
        if (trigger.active !== active) {
          classes[active ? 'add' : 'remove'](trigger.className)
          trigger.active = active
        }
      })
    }
  }, true)

  document.querySelector('#header .leuschke-brand').addEventListener('click', e => {
    window.scroll({
      top: offset(document.querySelector('#intro')).top,
      behavior: 'smooth'
    })
  })

  peopleSetup()
}

function initContent (container) {
  if (container) {
    // initialises newly loaded content
    const current = container.children

    // console.log(current)

    initContainers(current)
    // commonInit(current)
  }
  updateLinkState(document.querySelectorAll('#header, #footer, #content, #menu, #content-nav'))
}

docReady(() => {
  setup()
  initContent(document.querySelector('#content'))
  initContent(document.querySelector('#overlay .overlay-content'))

  document.body.classList.add('state-initialised')
})



// WEBPACK FOOTER //
// ./assets/j/src/site.js